export const headingStyles = {
	h1: "hmc-title-xl",
	h2: "hmc-title-l",
	h3: "hmc-title-m",
	h4: "hmc-title-s",
	h5: "hmc-title-xs",
	h6: "hmc-title-xs",
};
export const blockquoteStyles = "my-1 border-l-2 pl-6 italic";
export const indentationBase = 24; // px
export const listStyles = {
	ul: "list-disc [&_ul]:list-[circle] [&_ul_ul]:list-[square]",
	ol: "list-decimal",
};

export default {
	headingStyles,
	blockquoteStyles,
	indentationBase,
	listStyles,
};
